import { Component, Input, forwardRef, Inject, ElementRef } from '@angular/core';
import { AccordionComponent } from '../accordion.component';

@Component({
  selector: 'accordion-item',
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss'],
})
export class AccordionItemComponent {

  @Input() id: string = null;
  @Input() titulo: string;
  @Input() subtitulo: string;
  @Input() imageSRC: string;
  @Input() ativo = false;

  constructor(
    @Inject(forwardRef(() => AccordionComponent))
    private _parent: AccordionComponent,
    private myElement: ElementRef,
  ) { }

  changeAndNotify(): void {
    const id = this.myElement.nativeElement.id;
    this.toggleAtivo();
    this.myElement.nativeElement.removeAttribute('id');
    this.notifyParent();

    if (id) {
      if (this._parent.getUsarAncoras()) {
        location.hash = id;
      }
      this.myElement.nativeElement.setAttribute('id', id);
    }
  }

  toggleAtivo(): void {
    this.ativo = !this.ativo;
  }

  notifyParent(): void {
    this._parent.toggleChildren(this.id);
  }
}
